import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            读者心声
          </h2>
          <p className="mt-2 text-sm text-foreground-500">来自漫画爱好者的真实评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentsData.map((item) => (
            <div
              key={item.name}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <h3 className="text-sm font-medium text-foreground-950">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line w-3.5 h-3.5 flex items-center justify-center" />
                <span>{item.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}